import styled from 'styled-components';

export const StyledFetchTwinPresentation = styled.div`
  h2 {
    color: red;
  }
  h3 {
    color: green;
  }
`;
